// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","HomePage__header__menu":"su_a"};